import * as RedisApi from "../../../Api/RedisApi";
import * as redisClient from "../redisClient";
import { ACTIONS_TYPES } from "../../Reducers/redisClientReducer";
import { message, notification } from "antd";

// Success Notification Helper
const successNotification = (message) => {
  notification.success({
    message: "Success",
    description: message,
    duration: 3,
  });
};

// Error Notification Helper
const errorNotification = (message) => {
  notification.error({
    message: "Error",
    description: message,
    duration: 3,
  });
};

export const getAllRedisClient = (params = "") => {
  return async (dispatch) => {
    try {
      dispatch({
        type: ACTIONS_TYPES.REDIS_REQUEST,
      });
      let redis = {};
      const response = await RedisApi.getRedisClient(params);

      if (response?.status === 200) {
        redis = {
          data: response?.data?.data,
        };
      } else {
      }

      return dispatch(redisClient.getRedisClient(redis));
    } catch (error) {
      console.error("Error in fetching redis data: " + error);
      errorNotification("An error occurred while fetching Redis data.");
    } finally {
    }
  };
};

export const delRedisClient = (props) => {
  return async (dispatch) => {
    try {
      const response = await RedisApi.delRedisClient(props);

      if (response?.status === 200) {
        successNotification(response?.data?.message);
      } else {
        errorNotification("Failed to delete Redis client.");
      }
    } catch (error) {
      console.error("Error in deleting Redis client: " + error);
      errorNotification("An error occurred while deleting Redis client.");
    } finally {
      dispatch(getAllRedisClient());
    }
  };
};
